import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'main',
        component: () => import('../components/Front/mainComponent.vue')
    },
    {
        path: '/admin/login',
        name: 'login',
        component: () => import('../components/Admin/Auth/loginComponent.vue'),
        meta: { requiresLogout: true }
    },
    {
        path: '/admin/reset-password',
        name: 'reset-password',
        component: () => import('../components/Admin/Auth/resetPasswordComponent.vue'),
        meta: { requiresLogout: true }
    },
    {
        path: '/admin/input-new-password',
        name: 'input-new-password',
        component: () => import('../components/Admin/Auth/inputNewPasswordComponent.vue'),
        meta: { requiresLogout: true }
    },
    {
        path: '/admin',
        name: 'admin',
        component: () => import('../components/Admin/adminComponent.vue'),
        children: [
            {
                path: '/',
                name: 'admin-main',
                component: () => import('../components/Admin/Main/mainComponent.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'services',
                name: 'services',
                component: () => import('../components/Admin/Services/servicesComponent.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'reviews',
                name: 'reviews',
                component: () => import('../components/Admin/Reviews/reviewsComponent.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'messages',
                name: 'messages',
                component: () => import('../components/Admin/Messages/messagesComponent.vue'),
                meta: { requiresAuth: true }
            }
        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    routes
})

router.beforeEach((to, from, next) => {
    const isAuthenticated = store.getters.loggedUserVivamus !== null

    if (to.matched.some(record => record.meta.requiresAuth)) {

        if (!isAuthenticated) {
            return next({ name: 'login' })
        }
        return next()
    }

    if (to.matched.some(record => record.meta.requiresLogout)) {
        if (isAuthenticated) {
            return next({ name: 'admin-main' })
        }
        return next()
    }

    return next()
})

export default router
